import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgDownloadMid = function SvgDownloadMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C12.4142 3 12.75 3.33579 12.75 3.75V13.1893L14.9697 10.9697C15.2626 10.6768 15.7374 10.6768 16.0303 10.9697C16.3232 11.2626 16.3232 11.7374 16.0303 12.0303L12.5303 15.5303C12.2374 15.8232 11.7626 15.8232 11.4697 15.5303L7.96967 12.0303C7.67678 11.7374 7.67678 11.2626 7.96967 10.9697C8.26256 10.6768 8.73744 10.6768 9.03033 10.9697L11.25 13.1893V3.75C11.25 3.33579 11.5858 3 12 3ZM3.75 14C4.16421 14 4.5 14.3358 4.5 14.75V18.25C4.5 18.9404 5.05964 19.5 5.75 19.5H18.25C18.9404 19.5 19.5 18.9404 19.5 18.25V14.75C19.5 14.3358 19.8358 14 20.25 14C20.6642 14 21 14.3358 21 14.75V18.25C21 19.7688 19.7688 21 18.25 21H5.75C4.23122 21 3 19.7688 3 18.25V14.75C3 14.3358 3.33579 14 3.75 14Z"
  })));
};

export { SvgDownloadMid as ReactComponent };
//# sourceMappingURL=download-mid.svg.js.map
